import { Merchant } from 'common/api-types/director';

import { TenantRoute, getTenantConfig } from '../../../config/tenantConfig';

export function getTenantRoutePath(tenantId: Merchant['id'] | undefined, pathname: string) {
  // Remove the base path from the pathname
  const basePath = __ROUTER_BASE_URL__ || '/';
  const normalizedPathname = pathname.replace(new RegExp(`^${basePath}`), '/');

  const configRoutes = Object.keys(getTenantConfig(tenantId).routes);
  return configRoutes.find((route) => normalizedPathname.startsWith(`/${route}`)) as
    | TenantRoute
    | undefined;
}
